// extracted by mini-css-extract-plugin
module.exports = {"card":"workCard-module--card--2Y22_","tag":"workCard-module--tag--xIkqG"};